import * as React from 'react';

import { Image } from '../Image';

const icon = require('../../assets/inspect-element-icon.png');

export function InspectElementIcon(props: Partial<React.ComponentProps<typeof Image>>) {
  return <Image source={icon} {...props} />;
}
